import { useNavigate, useOutletContext } from 'react-router-dom';
import { DefaultBasePage } from '@components';
import { SectionType } from '@fdha/web-ui-library';

import { MealDeliveryContextData } from '../../components/meals/MealsLayout';

import { ReviewDeliveryPage } from './reviewDelivery/ReviewDeliveryPage';

const Delivery = () => {
  const navigate = useNavigate();
  const {
    deliveryId,
    isCanceled,
    deliveryStatus,
    patientId,
    foodProgramUserId,
    deliveryMenuId,
    allowSelfPreparedMeals,
    headerTitle,
  } = useOutletContext<MealDeliveryContextData>();

  const handleAddItems = (itemType: SectionType) => {
    navigate(`/meals/${deliveryId}/choose-meals?itemType=${itemType}`);
  };

  return (
    <DefaultBasePage
      title={headerTitle.fallback}
      i18nKeyTitle={headerTitle.i18nKey}
      i18nTitleParams={headerTitle.i18nParams}
      currentRouteName={{
        i18nKey: headerTitle.i18nKey,
        i18nParams: headerTitle.i18nParams,
        text: headerTitle.fallback,
      }}
      contentSize="large"
    >
      <ReviewDeliveryPage
        deliveryId={deliveryId}
        patientId={patientId}
        foodProgramUserId={foodProgramUserId}
        deliveryMenuId={deliveryMenuId}
        status={deliveryStatus}
        isCanceled={isCanceled}
        allowSelfPreparedMeals={allowSelfPreparedMeals}
        onAddItems={handleAddItems}
      />
    </DefaultBasePage>
  );
};

export default Delivery;
